import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class LedgerDetailUseCase extends BaseUseCase {
    constructor(LedgerRepo) {
        super();
        this.LedgerRepo = LedgerRepo;
    }
    async fetchResult(req) {
        return await this.LedgerRepo.getLedgerDetail(req);
    }
}
export default LedgerDetailUseCase;
